'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Ellipsis = require('./Ellipsis');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Ellipsis).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Ellipsis/index.js
// module id = 1174
// module chunks = 1